import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["name", "id"]
const _hoisted_2 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("select", {
    class: "formselect",
    name: _ctx.name,
    id: _ctx.id,
    onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOnChange && _ctx.handleOnChange(...args)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("option", {
        key: index,
        value: option.value,
        selected: option.value === _ctx.value
      }, _toDisplayString(option.text), 9, _hoisted_2))
    }), 128))
  ], 40, _hoisted_1))
}